import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Spinner from 'components/Common/Spinner';
import * as urls from 'routes/config';

import Dashboard from 'containers/Agency/Dashboard';
import Team from 'containers/Agency/Team';
import TeamForm from 'containers/Agency/Team/components/TeamMemberForm';
import Configuration from 'containers/Agency/Configuration';
import Billing from 'containers/Agency/Billing';
import Integrations from 'containers/Agency/Integrations';
import Integration from 'containers/Agency/Integrations/components/Integration';
import ConfigureIntegration from 'containers/Agency/Integrations/components/Configure';
import Twilio from 'containers/Agency/Configuration/Twilio';
import Llm from 'containers/Agency/Configuration/Llm';
import Stripe from 'containers/Agency/Configuration/Stripe';
import Smtp from 'containers/Agency/Configuration/Smtp';
import AgentTemplates from 'containers/Agency/AgentTemplate';
import AgentTemplateForm from 'containers/Agency/AgentTemplate/components/AgentTemplateForm';
import PromptForm from 'containers/Agency/Prompt/Components/PromptForm';
import Prompts from 'containers/Agency/Prompt';
import BusinessProfileForm from 'containers/Business/Setting/BusinessProfile';
import Usage from 'containers/Agency/Usage';
import Businesses from 'containers/Agency/Businesses';
import Plans from 'containers/Agency/Plans';
import Pricing from 'containers/Agency/Configuration/pricing';
import BrandingAndDomain from 'containers/Agency/Configuration/branding';
import Access from 'containers/Agency/Configuration/access';

export default function AgencyRoutes() {
  return (
    <Suspense fallback={<Spinner />}>
      <Routes>
        <Route index element={<Dashboard />} />
        <Route path={urls.agency.billing} element={<Billing />} />
        <Route path={urls.agency.usage} element={<Usage />} />
        <Route path={urls.agency.businesses} element={<Businesses />} />
        <Route path={urls.agency.businessProfileEdit()} element={<BusinessProfileForm agencyView={true} />} />
        <Route path={urls.agency.team} element={<Team />}>
          <Route path='add' element={<TeamForm />} />
          <Route path=':teamId' element={<TeamForm />} />
        </Route>
        <Route path={urls.agency.configuration} element={<Configuration />}>
          <Route index element={<Navigate to={urls.configuration.twilio} />} />
          <Route path={urls.configuration.twilio} element={<Twilio />} />
          <Route path={urls.configuration.llm} element={<Llm />} />
          <Route path={urls.configuration.stripe} element={<Stripe />} />
          <Route path={urls.configuration.smtp} element={<Smtp />} />
          <Route path={urls.configuration.pricing} element={<Pricing />} />
          <Route path={urls.configuration.branding} element={<BrandingAndDomain />} />
          <Route path={urls.configuration.access} element={<Access />} />
        </Route>
        <Route path={urls.agency.integrations} element={<Integrations />} />
        <Route path={urls.agency.integration} element={<Integration />}>
          <Route path={urls.agency.configureIntegration} element={<ConfigureIntegration />} />
        </Route>
        <Route path={urls.agency.agentTemplate} element={<AgentTemplates />}>
          <Route path='add' element={<AgentTemplateForm />} />
          <Route path=':agentTemplateId' element={<AgentTemplateForm />} />
        </Route>
        <Route path={urls.agency.plans} element={<Plans />} />
        <Route path={urls.agency.prompts} element={<Prompts />}>
          <Route path=':promptId' element={<PromptForm />} />
        </Route>
        <Route path='*' element={<Navigate to='/404' replace />} />
      </Routes>
    </Suspense>
  );
}
